import { Fade, LinearProgress, Slide } from '@mui/material';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../../../../Components/Modal/Modal';
import { Button, Input } from '../../../../Components/StyledComponents';
import CreateMenuGroup from './CreateMenuGroup';
import ReactDragListView from 'react-drag-listview';
import './MenuGroupInfo.scss';
import axios from 'axios';
import { alertRef } from '../../../../App';
import ModifyMenuGroup from './ModifyMenuGroup';

const MenuGroupInfo = () => {
    const [ isDrag, setIsDrag ] = React.useState(false)
    const [ list, setList ] = React.useState([])
    const [ data, setData ] = React.useState({})
    const [ isLoading, setIsLoading ] = React.useState(true)

    const modalRef = React.useRef(null);
    const modalModRef = React.useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        getMenuGroup();
    },[])

    const getMenuGroup = () => {
        setIsLoading(true)
        axios.get('/api/order/menu/group')
        .then((data) => {
            setList(data.data)
            setIsLoading(false)
        })
        .catch(() => {
            setIsLoading(false)
        })
    }

    // api : 메뉴그룹생성
    const createMenuGroup = (val) => {
        axios.post('/api/order/menu/group', val)
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                modalRef.current.closeModal();
                alertRef.current.showAlert({ title : '메뉴 그룹이 생성 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    // api : 메뉴그룹수정
    const modifyMenuGroup = (val) => {
        axios.patch('/api/order/menu/group',val)
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                modalModRef.current.closeModal();
                alertRef.current.showAlert({ title : '메뉴 그룹이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const removeMenuGroup = (id) => {
        axios.delete('/api/order/menu/group/' + id )
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                modalModRef.current.closeModal();
                alertRef.current.showAlert({ title : '메뉴 그룹이 삭제 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const patchGroupOrder = () => {
        let arr = [];
        for(let i=0; i < list.length; i++){
            arr.push(list[i]._id.$oid)
        }

        axios.patch('/api/order/menu/group/re_order',{
            GroupIds : arr
        })
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                modalModRef.current.closeModal();
                setIsDrag(false)
                alertRef.current.showAlert({ title : '그룹 순서가 변경 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
          if(!isDrag) return;
          const data = [...list];
          const item = data.splice(fromIndex, 1)[0];
          data.splice(toIndex, 0, item);
          setList([...data]);
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName : 'line',
    };

    return (
        <div className='menu-group-info'>
            <div className='header-row'>
                {/* <Input
                    style={{ width : 400 }}
                    placeholder="메뉴를 검색해보세요."
                /> */}
                <div></div>

                <div className='row'>
                    <Button variant="sub" small style={{ marginRight : 8, width : 112 }} onClick={() => setIsDrag(old => !old)}>
                        {isDrag ? '취소' : '순서변경'}
                    </Button>

                    {
                        isDrag ?
                        <Button variant="main" small style={{ width : 112 }} onClick={() => patchGroupOrder()}>
                            순서 저장
                        </Button>
                        :
                        <Button variant="main" small style={{ width : 112 }} onClick={() => modalRef.current.openModal()}>
                            메뉴 그룹 추가
                        </Button>
                    }
                </div>
            </div>
            
            {
                isLoading ?
                <LinearProgress color="error" />
                :
                <div className='divider'></div>
            }
                
            { 
                isLoading ?
                null
                :
                list.length > 0 ?
                <ReactDragListView {...dragProps}>
                    <ol style={{ margin : 0 , padding : 0}}>
                    {
                        list.map((data,i) =>(
                            <li key={i}>
                                <div className='menu-group-box' style={isDrag ? { padding : 24 } : {}}>
                                    <div onClick={() => {if(!isDrag)navigate("/order/menu/" + data._id.$oid)}}>
                                        <div className='row'>
                                            <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration : '0.4s', transitionDelay : '0.2s'}}>
                                                <p className='move-icon' style={{ width : isDrag ? 64 : 0, transition : 'all', transitionDuration : '0.2s' }}>
                                                    <img src={require('../../../../aseets/icons/menu-drag.svg').default} style={{ width : 24, height : 24, pointerEvents : 'none' }} />
                                                </p>
                                            </Slide>
                                            <p className='menu-name'>{data.Name}</p>
                                        </div>
                                        <p className={`menu-desc`} style={isDrag ? { display : 'none' } : {}}>
                                            {
                                                data.MenuInfo.map((item,index) => {
                                                    return item.Name +( index === data.MenuInfo.length -1 ? '' : ', ')
                                                })
                                            }
                                        </p>
                                    </div>
                                    <div className='row' style={{ alignItems : 'center', justifyContent : 'center',  height : isDrag ? 0 : 'fit-content', opacity : isDrag ? 0 : 1, transition : 'all', transitionDuration : '0.5s' }}>
                                        <button className='mod-btn' onClick={() => {setData(data);modalModRef.current.openModal()}}>
                                            수정하기
                                        </button>
                                        <button className='remove-btn' onClick={() => alertRef.current.showAlert({ title : `정말 메뉴 그룹을 삭제하시겠어요?`, isConfirm : true, confirmText : '삭제', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();removeMenuGroup(data._id.$oid)} })}>
                                            <img src={require('../../../../aseets/icons/delete.svg').default} style={{ width : 24, height :24 }} />
                                        </button>
                                    </div>
                                </div>
                            </li>
                        ))
                    }
                    </ol>
                </ReactDragListView>
                :
                <div>
                    <p className='empty-list'>생성된 메뉴가 없습니다.</p>
                </div>
            }

            <Modal ref={modalRef} contentContainer={{width : 500 }} isHeader title="메뉴 그룹 추가">
                <CreateMenuGroup createMenuGroup={createMenuGroup}/>
            </Modal>

            <Modal ref={modalModRef} contentContainer={{width : 500 }} isHeader title="메뉴 그룹 수정">
                <ModifyMenuGroup modifyMenuGroup={modifyMenuGroup} info={data}/>
            </Modal>
        </div>
    )
}

export default MenuGroupInfo;